/*
 * decaffeinate suggestions:
 * DS002: Fix invalid constructor
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
import React from 'react';
import * as ReactDnD from 'react-dnd';
import PropTypes from 'prop-types';
import * as Constants from '../constants';

import { AttendeeQuestionForm } from './attendee_question_form.jsx';

class AttendeeQuestionListItem extends React.Component {
  static propTypes = {
          // Can this question be edited
          editable: PropTypes.bool,
          // Is the editor shown
          showEditor: PropTypes.bool,
          // Is the question a platform, or per event
          defaultQuestion: PropTypes.bool,
          onChange: PropTypes.func,
          onDelete: PropTypes.func,
          onToggleEditor: PropTypes.func,
          onDragUpdate: PropTypes.func,
          onDragCancel: PropTypes.func,
          onDragStart: PropTypes.func,
          onDragFinish: PropTypes.func,
          onChoiceAdd: PropTypes.func,
          onChoiceChange: PropTypes.func,
          onChoiceDelete: PropTypes.func,
          // Callback for choice drag start
          onChoiceDragStart: PropTypes.func,
          // Callback for choice drag update
          onChoiceDragUpdate: PropTypes.func,
          // Callback for choice drag finish
          onChoiceDragFinish: PropTypes.func,
          // Callback for choice drag cancel
          onChoiceDragCancel: PropTypes.func
        };

  static defaultProps = {
          editable: true,
          defaultQuestion: false,
          showEditor: false
        };

  constructor(...args) {
    super(...args);
    this.toggleEditForm = this.toggleEditForm.bind(this);
    this.closeForm = this.closeForm.bind(this);
    this.formChange = this.formChange.bind(this);
    this.deleteTicket = this.deleteTicket.bind(this);
  }

      toggleEditForm(event) {
        event.preventDefault();
        return (typeof this.props.onToggleEditor === 'function' ? this.props.onToggleEditor(this.props.question.id) : undefined);
      }

      closeForm(event) {
        event.preventDefault();
        return (typeof this.props.onToggleEditor === 'function' ? this.props.onToggleEditor(this.props.question.id, false) : undefined);
      }

      formChange(name, value, event) {
        return (typeof this.props.onChange === 'function' ? this.props.onChange(this.props.question.id, name, value, event) : undefined);
      }

      deleteTicket(event) {
        event.preventDefault();
        return (typeof this.props.onDelete === 'function' ? this.props.onDelete(this.props.question.id, event) : undefined);
      }

      render() {
        const edit_form = this.props.showEditor ?
          <AttendeeQuestionForm question={this.props.question}
                                 onClose={this.closeForm}
                                 onChange={this.formChange}
                                 onChoiceAdd={this.props.onChoiceAdd}
                                 onChoiceChange={this.props.onChoiceChange}
                                 onChoiceDelete={this.props.onChoiceDelete}
                                 onChoiceDragStart={this.props.onChoiceDragStart}
                                 onChoiceDragUpdate={this.props.onChoiceDragUpdate}
                                 onChoiceDragFinish={this.props.onChoiceDragFinish}
                                 onChoiceDragCancel={this.props.onChoiceDragCancel} /> : undefined;

        return this.props.connectDropTarget(this.props.connectDragPreview(<tbody>
          <tr>
            <td>
              {this.props.editable && this.props.connectDragSource(<i className="fa fa-bars drag-handle" aria-hidden="true"/>)}
              {this.props.question.question}
              {this.props.question.required && <sup className="required">Required</sup>}
              {this.props.defaultQuestion && <sup className="required">Global Question</sup>}
            </td>
            <td>
              {this.props.editable && <div className="text-right action_icon_button">
                <a href="#"
                   onClick={this.toggleEditForm}
                   title="Edit Attendee Question"
                   className="edit_button"><i className="localist-icon-edit-small"></i></a>
                <a href="#"
                   onClick={this.deleteTicket}
                   title="Remove Attendee Question"
                   className="deletex_button"><i className="localist-icon-trash-small"></i></a>
              </div>}
            </td>
          </tr>
          {edit_form}
        </tbody>
        )
        );
      }
}

// DnD drag specification
    const dragSpec = {
      beginDrag(props, monitor, component) {
        const item = { id: props.question.id, position: props.question.position };
        if (typeof props.onDragStart === 'function') {
          props.onDragStart(item);
        }
        return item;
      },

      endDrag(props, monitor, component) {
        if (monitor.didDrop()) {
          const result = monitor.getDropResult();
          return (typeof props.onDragFinish === 'function' ? props.onDragFinish(result) : undefined);
        } 
          return (typeof props.onDragCancel === 'function' ? props.onDragCancel({id: props.question.id, position: props.question.position}) : undefined);
        
      }
    };

    const dragCollect = (connect, monitor) => ({
      isDragging: monitor.isDragging(),
      connectDragSource: connect.dragSource(),
      connectDragPreview: connect.dragPreview()
    });

    // Drop specification
    const dropSpec = {
      drop(props, monitor, component) {
        if (!monitor.didDrop()) { return { position: props.question.position }; }
      },

      hover(props, monitor, component) {
        if (monitor.canDrop() && monitor.isOver({shallow: true})) {
          const item = monitor.getItem();
          if (item.id !== props.question.id) {
            return (typeof props.onDragUpdate === 'function' ? props.onDragUpdate(item, props.question.position) : undefined);
          }
        }
      }
    };

    const dropCollect = (connect, monitor) => ({
      hovered: monitor.isOver(),
      connectDropTarget: connect.dropTarget()
    });

const AttendeeQuestionListItemDragSource = ReactDnD.DragSource(Constants.DRAG_TYPE_ATTENDEE_QUESTION, dragSpec, dragCollect)(AttendeeQuestionListItem);
export const AttendeeQuestionListItemContainer = ReactDnD.DropTarget(Constants.DRAG_TYPE_ATTENDEE_QUESTION, dropSpec, dropCollect)(AttendeeQuestionListItemDragSource);
